import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-click',
  templateUrl: './icon-click.component.html',
  styleUrls: ['./icon-click.component.scss'],
})
/**
 * Circled icon with some action after click
 */
export class IconClickComponent {
  private _small: boolean = false;

  /**
   * Decides if the component size is small
   * @return {boolean}
   */
  @Input()
  get small(): boolean {
    return this._small;
  }

  /**
   * Sets this component size as small by using an html attribute
   * @param {any} value
   */
  set small(value: any) {
    this._small = coerceBooleanProperty(value);
  }
}
